// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f6fcd37c","453":"a536ed64","588":"521ba3f7","944":"722c43de","996":"99eb783c"}[chunkId] + ".chunk.js";
};